/** @jsx jsx */
import { Link } from 'gatsby'
import { Box, jsx } from 'theme-ui'

const NavMenuSubmenu = ({ isOpen, page }) => {
  return (
    <Box
      as="ul"
      sx={{
        backgroundColor: [null, null, 'white'],
        borderBottom: ['1px solid', null, '0'],
        borderBottomColor: 'white',
        boxShadow: [null, null, '0px 5px 15px 0px rgba(0, 0, 0, 0.2)'],
        display: [isOpen ? 'block' : 'none', null, 'block'],
        left: [null, null, '-9px'],
        listStyleType: 'none',
        m: 0,
        opacity: [null, null, isOpen ? '1' : '0'],
        position: [null, null, 'absolute'],
        px: 0,
        py: [2, null, 1],
        textAlign: ['center', null, 'left'],
        transition: [null, null, 'all .15s ease-in-out'],
        top: [null, null, '100%'],
        visibility: [null, null, isOpen ? 'visible' : 'hidden'],
        width: [null, null, '200px'],
        '*:hover > &': {
          opacity: '1',
          visibility: 'visible',
        },
      }}
    >
      {page.pages.map((page) => {
        let to = `/${page.slug}/`

        if (page.__typename === 'ContentfulPack') {
          to = `/products/${page.slugUrl || page.slug}/`
        }

        return (
          <Box
            as="li"
            key={page.id}
            sx={{
              display: [null, null, 'block'],
            }}
          >
            <Link
              to={to}
              sx={{
                color: ['white', null, 'black'],
                cursor: 'pointer',
                display: 'block',
                fontFamily: 'body',
                fontSize: ['16px', null, '18px'],
                fontWeight: 'regular',
                letterSpacing: '.25px',
                lineHeight: [null, null, '28px'],
                px: [null, null, 3],
                py: [2, null, 1],
                textAlign: ['center', null, 'left'],
                textDecoration: 'none',
                '&:hover': {
                  color: [null, null, 'brandTertiary'],
                },
              }}
            >
              {page.headerNavTitle || page.name}
            </Link>
          </Box>
        )
      })}
    </Box>
  )
}

export default NavMenuSubmenu
